export default __webpack_public_path__ + "static/media/info2.ae0e0ad5.svg";